export { LossRegistration } from './LossRegistration';
